module.exports = __webpack_public_path__ + "static/media/cheveron-left.e6497c8a.svg";